export const languages = {
  uk: 'Українська',
  ru: 'Русский'
}
